import { Redacted, Schema } from "effect";
import { privateDependencyFailure } from "@workerstation/shared/errors/private-cause";

export const PanelDestination = Schema.String;
export const PanelBounds = Schema.Struct({ left: Schema.Number, top: Schema.Number, width: Schema.Number, height: Schema.Number });
export type PanelBounds = typeof PanelBounds.Type;
export class PanelPlacementFailure extends privateDependencyFailure<PanelPlacementFailure>()("PanelPlacementFailure", "editor panel placement") {}
export const panelPlacementFailure = (cause: unknown) => new PanelPlacementFailure({ cause: Redacted.make(cause) });
